import React from 'react'

import { createSvgIcon } from './utils/create-svg-icon'

export const CircleRightIcon = createSvgIcon(
  <>
    <title>circle right</title>
    <g
      className="nc-icon-wrapper"
      fill="#222222"
      stroke="#222222"
      strokeLinecap="square"
      strokeLinejoin="miter"
      strokeWidth="1"
      transform="translate(0.5 0.5)"
    >
      <circle
        cx="16"
        cy="16"
        fill="none"
        r="15"
        stroke="#222222"
        strokeMiterlimit="10"
      />{' '}
      <polyline
        data-color="color-2"
        fill="none"
        points=" 13,10 19,16 13,22 "
        strokeMiterlimit="10"
      />
    </g>
  </>
)
